import React, { useState, useEffect } from "react";
import axios from "axios";

export default function AddFundsPage() {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("");
  const storedFunds = (() => {
  try {
    return JSON.parse(localStorage.getItem("fundHistory")) || [];
  } catch {
    return [];
  }
})();

const [funds, setFunds] = useState(storedFunds);

  // ⬅️ Payment Numbers State
// 🔥 HYDRATE SETTINGS FROM CACHE FIRST
const storedSettings = (() => {
  try {
    return JSON.parse(localStorage.getItem("paymentSettings")) || {};
  } catch {
    return {};
  }
})();

const [settings, setSettings] = useState({
  bkash: storedSettings.bkash || "",
  nagad: storedSettings.nagad || "",
  rocket: storedSettings.rocket || "",
  bkashInstruction: storedSettings.bkashInstruction || "",
  nagadInstruction: storedSettings.nagadInstruction || "",
  rocketInstruction: storedSettings.rocketInstruction || "",
  bkashActive: storedSettings.bkashActive ?? true,
  nagadActive: storedSettings.nagadActive ?? true,
  rocketActive: storedSettings.rocketActive ?? true
});
// ⬅️ Load Settings From Admin Panel
useEffect(() => {
  const loadSettings = async () => {
    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/settings");
      const updatedSettings = {
  bkash: res.data.bkash || "",
  nagad: res.data.nagad || "",
  rocket: res.data.rocket || "",
  bkashInstruction: res.data.bkashInstruction || "",
  nagadInstruction: res.data.nagadInstruction || "",
  rocketInstruction: res.data.rocketInstruction || "",
  bkashActive: res.data.bkashActive ?? true,
  nagadActive: res.data.nagadActive ?? true,
  rocketActive: res.data.rocketActive ?? true
};

setSettings(updatedSettings);
localStorage.setItem("paymentSettings", JSON.stringify(updatedSettings));
      setSettings((prev) => ({
  ...prev,
  bkashActive: res.data.bkashActive ?? true,
  nagadActive: res.data.nagadActive ?? true,
  rocketActive: res.data.rocketActive ?? true
}));
    } catch (err) {
      console.error("⚠ Failed to load settings", err);
    }
  };

  loadSettings();
}, []);


  // 🔥 Realtime Sync for user balance
  useEffect(() => {
    const updateUser = () => {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
    };
    window.addEventListener("userUpdated", updateUser);
    return () => window.removeEventListener("userUpdated", updateUser);
  }, []);

  // ✅ Logged-in user info
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const username = storedUser?.username || "";

  useEffect(() => {
    fetchFunds();
  }, []);

  // ✅ Fetch fund history
  const fetchFunds = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const res = await axios.get("https://api.speedfollowinfo.com/api/funds/my-funds", {
        headers,
      });

      const data = Array.isArray(res.data)
        ? res.data
        : res.data.funds || [];

      setFunds(data);
    } catch (err) {
      console.error("❌ Fund fetch failed:", err.response?.data || err.message);
      setFunds([]);
    }
  };

  // ✅ Pay Now Handler — NOW min = 50
  const handleSubmit = (e) => {
    e.preventDefault();

    // 🚨 Amount empty popup (Replace this instead of alert)
if (!amount) {
  const popup = document.createElement("div");
  popup.innerHTML = `
    <div style="
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.8);
      display: flex; align-items: center; justify-content: center;
      z-index: 999999;
    ">
      <div style="
        background: #1a0b0b;
        border: 2px solid #ff0000;
        padding: 30px;
        width: 90%; max-width: 380px;
        border-radius: 15px;
        text-align: center;
        color: white;
        box-shadow: 0 0 30px rgba(255,0,0,0.7);
        animation: popIn 0.18s ease-out;
      ">
        
        <div style="font-size: 65px; margin-bottom: 5px;">🚫</div>
        
        <h2 style="font-size: 26px; font-weight: bold; color: #ff4444; margin-bottom: 10px;">
          AMOUNT REQUIRED
        </h2>
        
        <p style="font-size: 17px; color: #ffbbbb; margin-bottom: 15px;">
          Please Enter An Amount Before Continuing
        </p>

        <p style="font-size: 18px; font-weight: bold; color: #ff7777; margin-bottom: 25px;">
          তুমি কি কানা নাকি 🤨 <br/>
          Amount লিখে Pay Now দাও!
        </p>

        <button style="
          background: #ff3333;
          padding: 10px 25px;
          border: none;
          border-radius: 8px;
          color: white;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: 0.2s;
        ">ঠিক আছে 😐</button>

      </div>
    </div>
  `;

  popup.querySelector("button").onclick = () => popup.remove();
  document.body.appendChild(popup);
  return;
}

    const num = Number(amount);

    if (isNaN(num) || num < 50) {
  const popup = document.createElement("div");

  popup.innerHTML = `
    <div style="
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
    ">
      <div style="
        background: linear-gradient(180deg,#3a0000,#150000);
        padding: 30px;
        width: 90%;
        max-width: 420px;
        border-radius: 14px;
        text-align: center;
        border: 2px solid #ff0000;
        box-shadow: 0 0 30px rgba(255,0,0,0.7);
        animation: popDanger 0.25s ease-out;
      ">

        <div style="font-size: 70px; margin-bottom: 10px;">🚫</div>

        <h2 style="font-size: 28px; font-weight: 800; color: #ff4444; margin-bottom: 10px;">
          ALERT : Minimum Add Amount ৳50
        </h2>

        <p style="font-size: 17px; color: #ffcccc; line-height: 1.6; margin-bottom: 20px;">
          ঐখানে লিখা আছে ৫০ টাকার কম Add হবে না ⚠️ <br><br>
          তুমি ৳${num || 0} টাকা এড করতে পারবা না 😂
        </p>

        <div style="display: flex; gap: 10px; justify-content: center;">
          <button id="poorBtn" style="
            flex: 1;
            background: #ff2222;
            padding: 10px;
            border-radius: 8px;
            border: none;
            color: white;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
          ">আমি দুঃখিত 🥹</button>

          <button id="sorryBtn" style="
            flex: 1;
            background: #b30000;
            padding: 10px;
            border-radius: 8px;
            border: none;
            color: white;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
          ">আর হবে না 🙏</button>
        </div>

      </div>
    </div>

    <style>
      @keyframes popDanger {
        0% { transform: scale(0.7); opacity: 0; }
        100% { transform: scale(1); opacity: 1; }
      }
    </style>
  `;

  popup.querySelector("#poorBtn").onclick = () => popup.remove();
  popup.querySelector("#sorryBtn").onclick = () => popup.remove();

  document.body.appendChild(popup);
  return;
}

    // Redirect to Payment
    window.location.href = `/payment?method=${method}&amount=${num}`;
  };

  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white p-6">
      <h1 className="text-3xl font-bold mb-4 text-[#f2a900]">💰 Add Funds</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* ---------------- LEFT: Add Fund ---------------- */}
        <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
          <h2 className="text-xl font-bold mb-3 text-purple-400">Add Fund</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            
            // Payment Method
<div>
  <label className="block mb-1 text-gray-300">Method</label>
  <select
  value={method}
  onChange={(e) => setMethod(e.target.value)}
  className="w-full p-3 rounded bg-[#1b2142] border border-[#2f3b6c]"
>
  {/* Default option — No auto select */}
  <option value="">-- Select Payment Method --</option>

  {/* Bkash */}
  <option
    value="Bkash"
    disabled={!settings.bkashActive}  
  >
    Bkash (
      {settings.bkashActive ? settings.bkash : "Coming soon with new"}
    )
  </option>

  {/* Nagad */}
  <option
    value="Nagad"
    disabled={!settings.nagadActive}
  >
    Nagad (
      {settings.nagadActive ? settings.nagad : "Coming soon with new"}
    )
  </option>

  {/* Rocket */}
  <option
    value="Rocket"
    disabled={!settings.rocketActive}
  >
    Rocket (
      {settings.rocketActive ? settings.rocket : "Coming soon with new"}
    )
  </option>
</select>
</div>

            {/* Amount Input */}
            <div>
              <label className="block mb-1 text-gray-300">Amount (৳)</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter Amount"
                className="w-full p-3 rounded bg-[#1b2142] border border-[#2f3b6c]"
              />
            </div>

            {/* Pay Now Button */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-purple-500 to-indigo-600 py-3 rounded-lg font-semibold hover:opacity-90 transition"
            >
              Pay Now
            </button>
          </form>

          {/* Info Section */}
<div className="mt-6 text-sm bg-[#0f1530] p-4 rounded-lg leading-relaxed">

  {/* New Static Instruction Block */}
  <div className="leading-relaxed text-gray-300">

    <p>💰 <b>Dollar Rate:</b> 1$ = 130৳</p>
    <p>🔻 <b>Minimum Add:</b> 0.38$ / 50৳</p>

    <p className="mt-3">
      ⚠️ পেমেন্ট যদি সাথে সাথে এড না হয় অথবা কোনো সমস্যা হয়,  
      তাহলে ৫-১০ মিনিট অপেক্ষা করে আবার চেষ্টা করবেন।
    </p>

    <p className="mt-3">
      ⚠️ যেকোনো সমস্যায় Whatsapp এর মাধ্যমে যোগাযোগ করবেন। ধন্যবাদ।
    </p>

    <p className="mt-3 text-red-300">
      দয়া করে প্রদত্ত নম্বরগুলিতে কল করবেন না — এগুলো ভাড়া নেওয়া সাময়িক নম্বর।  
      কল করলে আপনার অ্যাকাউন্ট স্থায়ীভাবে BAN হয়ে যাবে।
    </p>

    <p className="mt-3">
      যেকোনো পেমেন্ট-সংক্রান্ত সমস্যার জন্য আমাদের Whatsapp এ যোগাযোগ করুন।
    </p>

    <p className="mt-3 font-bold text-green-400">
      ৫০ টাকায় পাবেন = {(50 / 130).toFixed(3)} $
    </p>
  </div>
  </div>
  
</div>
        {/* ---------------- RIGHT: Fund History ---------------- */}
        <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
          <h2 className="text-xl font-bold mb-4 text-purple-400">💸 Fund History</h2>

          <div className="overflow-y-auto max-h-[500px]">
            <table className="w-full text-left text-sm border-collapse">
              <thead>
                <tr className="text-gray-400 border-b border-[#2f3b6c]">
                  <th className="py-2 px-2">ID</th>
                  <th className="py-2 px-2">Date</th>
                  <th className="py-2 px-2">Method</th>
                  <th className="py-2 px-2 text-right">Amount</th>
                  <th className="py-2 px-2 text-center">Status</th>
                  <th className="py-2 px-2 text-center">Info</th>
                </tr>
              </thead>

              <tbody>
                {funds.map((f) => (
                  <tr key={f._id} className="border-b border-[#2f3b6c]">
                    <td className="py-2 px-2">{f._id.slice(-5)}</td>
                    <td className="py-2 px-2">
                      {new Date(f.createdAt).toLocaleString("en-GB")}
                    </td>
                    <td className="py-2 px-2">{f.method}</td>
                    <td className="py-2 px-2 text-right">৳{f.amount}</td>

                    {/* Status Color */}
                    <td
                      className={`py-2 px-2 text-center font-semibold ${
                        f.status === "Approved"
                          ? "text-green-400"
                          : f.status === "Pending"
                          ? "text-yellow-400"
                          : "text-red-400"
                      }`}
                    >
                      {f.status === "Approved"
                        ? "✅ Complete"
                        : f.status === "Pending"
                        ? "🕓 Pending"
                        : "❌ Cancelled"}
                    </td>

                    {/* Admin Cancel Note */}
                    <td className="py-2 px-2 text-center">
                      {f.status === "Cancelled" && f.reason ? (
                        <button
                          onClick={() =>
                            alert(`❌ Admin Note:\n\n${f.reason}`)
                          }
                          className="bg-[#2f3b6c] hover:bg-[#3b4585] text-white px-2 py-1 rounded-full text-xs"
                          title="View Reason"
                        >
                          ℹ️
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* No History */}
            {funds.length === 0 && (
              <div className="text-center py-6 text-gray-400">
                No fund history yet.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}